import React from "react";
import { Link } from "react-router-dom";
import {
  HOUSING_COMPARISON_ROWS,
  HOUSING_MISTAKES,
  HOUSING_SOURCES,
  OWNER_PILLARS,
} from "../../content/housingProgramGuideData";
import { GuideSection, guideBodyClass, guideSectionTitleClass } from "./guideSection";
import HousingProgramFaq from "./HousingProgramFaq";

export default function HousingProgramGuideAudience() {
  return (
    <>
      <GuideSection id="proprietarios" title="Para proprietários">
        <p className={guideBodyClass}>
          Administrar a locação de uma unidade HIS ou HMP exige atrair o público adequado, verificar
          o enquadramento do interessado e conduzir a locação conforme a categoria.
        </p>
        <ul className="m-0 flex list-disc flex-col gap-1 pl-5 text-sm text-[#3d4754]">
          {OWNER_PILLARS.map((pillar) => (
            <li key={pillar.title}>
              <span className="font-semibold text-[#1f2933]">{pillar.title}.</span> {pillar.body}
            </li>
          ))}
        </ul>
      </GuideSection>

      <GuideSection id="inquilinos" title="Para inquilinos">
        <p className={guideBodyClass}>
          Se a renda está dentro das faixas de HIS ou HMP, é possível encontrar imóveis em
          diferentes regiões de São Paulo. A 7Cantos ajuda a identificar o enquadramento, encontrar
          unidades compatíveis, reunir a documentação e concluir a locação.
        </p>
      </GuideSection>

      <GuideSection id="investidores" title="O que muda para quem investe?">
        <p className={guideBodyClass}>
          Uma unidade HIS ou HMP pode fazer parte de uma estratégia imobiliária, mas não tem as
          mesmas possibilidades de uso de uma unidade de mercado livre. Há regras de público
          elegível, de valor de comercialização e locação, e a curta temporada está vedada em São
          Paulo. Antes de calcular rentabilidade, considere quem poderá alugar, qual valor poderá
          ser praticado, a demanda da região, a vacância esperada e os custos da operação.
        </p>
      </GuideSection>

      <GuideSection id="comparativo" title="HIS/HMP e imóvel convencional">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[28rem] border-collapse text-left text-sm text-[#3d4754]">
            <thead>
              <tr className="border-b border-[#eadfd6]">
                {["Característica", "HIS/HMP", "Residencial convencional"].map((header) => (
                  <th key={header} className="px-3 py-2 font-semibold text-[#1f2933]">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {HOUSING_COMPARISON_ROWS.map((row) => (
                <tr key={row[0]} className="border-b border-[#eadfd6]">
                  {row.map((cell) => (
                    <td key={cell} className="px-3 py-2">
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </GuideSection>

      <GuideSection id="erros" title="Erros comuns">
        <ul className="m-0 flex list-disc flex-col gap-2 pl-5 text-sm text-[#3d4754]">
          {HOUSING_MISTAKES.map((item) => (
            <li key={item.myth}>
              <span className="font-semibold text-[#1f2933]">{item.myth}</span> {item.fact}
            </li>
          ))}
        </ul>
      </GuideSection>

      <GuideSection id="faq" title="Perguntas frequentes">
        <HousingProgramFaq />
      </GuideSection>

      <GuideSection id="fontes" title="Legislação e fontes">
        <ul className="m-0 flex list-disc flex-col gap-1 pl-5 text-sm">
          {HOUSING_SOURCES.map((source) => (
            <li key={source.href}>
              <a href={source.href} target="_blank" rel="noreferrer" className="text-[#dd6435] underline">
                {source.label}
              </a>
            </li>
          ))}
        </ul>
      </GuideSection>

      <section className="flex flex-col gap-3">
        <h3 className={guideSectionTitleClass}>Próximo passo</h3>
        <p className={guideBodyClass}>
          A 7Cantos ajuda proprietários a colocar unidades HIS e HMP no mercado e ajuda inquilinos a
          encontrar um imóvel compatível com a renda. Dúvidas sobre um imóvel específico:{" "}
          <a className="text-[#dd6435] underline" href="mailto:contato@7cantos.com">
            contato@7cantos.com
          </a>{" "}
          ou 4003-7654.
        </p>
        <div className="flex flex-col gap-2 sm:flex-row">
          <Link
            to="/search"
            className="inline-flex justify-center rounded-full bg-[#dd6435] px-4 py-2 text-sm font-semibold text-white"
          >
            Ver imóveis
          </Link>
          <Link
            to="/anunciar-imovel"
            className="inline-flex justify-center rounded-full border border-[#dd6435] px-4 py-2 text-sm font-semibold text-[#dd6435]"
          >
            Anunciar imóvel
          </Link>
        </div>
      </section>
    </>
  );
}
